import { render } from "./columnSetting.vue?vue&type=template&id=e72aa40a&scoped=true"
import script from "./columnSetting.vue?vue&type=script&lang=js"
export * from "./columnSetting.vue?vue&type=script&lang=js"

import "./columnSetting.vue?vue&type=style&index=0&id=e72aa40a&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\qfy-all\\qfy-oms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72aa40a"]])

export default __exports__